import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    getNotificationResponse: [],
    updateNoticationsResponse: []
}

const NotificationReducer = (state = initState, { type, payload }) => {

    switch (type) {
        case CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.GET_NOTIFICATIONS_API_SUCCESS:
            return {
                ...state,
                getNotificationResponse: payload.value
            }

        case CONSTANTS.CONSTANTS_NOTIFICATIONS_MANAGEMENT.EDIT_NOTIFICATIONS_API_SUCCESS:
            return {
                ...state,
                updateNoticationsResponse: payload.value
            }

        default:
            return state
    }
}

export default NotificationReducer;
